<template>
  <div>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Edit Profile
          </h2>
        </div>
      </div>
    </div>
    <div class="px-6 py-8 bg-white menucontrol-scroll fixed-top">
      <First />
      <!-- <Second /> -->
    </div>
  </div>
</template>
<script>
import First from "./components/First.vue";
// import Second from "./components/Second.vue";

export default {
  components: {
    First,
    // Second,
  },
  methods: {},
};
</script>
